import {Component, Vue, Watch} from 'vue-property-decorator'
import menuData from '@/components/menuData/index.vue'
import MenuTree from './MenuTree.vue'

import {
    financeArchiveStatisticalDataDepartmentList,
    financeArchiveStatisticalData,
    setFinanceAchievementTask
} from '@/api/financial-center'
import {
    lastMonth,
    lastQuarter,
    lastWeek, lastYear,
    thisMonth,
    thisQuarter,
    thisToday,
    thisWeek, thisYear,
    thisYesterday
} from "@/utils/dateTime";
import {number} from "echarts";
import {Loading} from "element-ui";
import * as math from 'mathjs'

@Component({
    components:{ menuData ,MenuTree}
})
export default class ArchStatistical extends Vue {
    menuList = [
        {id: 1078, name: "二级BD海外", level: 2,children: [
            {id: 12, name: "三级BD海外1", level: 3,children:[
                {id: 22, name: "四级BD海外1", level: 4,children: [
                    {id: 32, name: "五级BD海外1", level: 5,children: [
                        {id: 42, name: "六级BD海外1", level: 6}
                    ]}
                ]}
            ]},
            {id: 13, name: "三级BD海外2", level: 3},
          ]},
        {id: 91, name: "二级视觉技术组", level: 2,children:[
            {id: 12, name: "三级视觉技术组1", level: 3},
            {id: 13, name: "三级视觉技术组2", level: 3},
        ]},
    ]
    departmentList = null
    tableData = []
    page = 1
    total = 0
    limit = 20
    // loading = false
    tableKey = Math.random()
    departmentId = ''
    lastId = ''  //当前展开id
    dataFilter = 5  //周期  默认本月
    name = '部门'  //部门、人员
    activeIndex = ''
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    timeStrDate = []
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    timeType = '1'
    timeStr = ''
    performanceTasksShow = false  //设置业绩任务弹框
    rateShow = false
    disBtn = false
    disBtn1 = false
    timeRateStr = ''
    startTime = ''
    endTime = ''
    performanceTasks = ''
    timeStrSecDate = []
    timeTypeNew = '1'
    raskShow = false
    taskTableShow = false
    SetEnrollmentNumbersVisible = false  //设置招生人数弹框
    performanceStudents = '' //招生人数
    tableColumn = [  //表头
        {
            id: 2,
            label: "部门人员",
            prop: "name",
            type: "",
            num:  Math.random(),
            children: [],

        },

        {
            id: 3,
            label: "学员数",
            prop: "customerNumber",
            type: "",
            children: [],
            num:  Math.random(),

        },
        {
            id: 4,
            label: "订单数",
            prop: "financeOrderNumber",
            type: "",
            num:  Math.random(),
            children: [],

        },
        {
            id: 7,
            label: "项目终端售价",
            prop: "souCoursePriceSum",
            type: "",
            num:  Math.random(),
            children: [],

        },
        {
            id: 5,
            label:"结算金额",
            prop: "financeOrderPriceSum",
            type: "",
            num:  Math.random(),
            children: [],

        },
        {
            id: 6,
            label: "回款金额",
            prop: "financeBackMoneySum",
            type: "",
            num:  Math.random(),
            children: [],

        },
        {
            id: 10,
            label: "平均签约成本（不含差旅招待）",
            prop: "averageCost",
            type: "",
            num:  Math.random(),
            children: [],
        },
        {
            id: 8,
            label: "业绩任务",
            prop: "taskVolume",
            type: "",
            num:  Math.random(),
            children: [],

        },
        {
            id: 9,
            label: "业绩完成率",
            prop: "taskVolumeRatio",
            type: "",
            num:  Math.random(),
            children: [],

        },
        {
            id: 10,
            label: "招生人数",
            prop: "taskCustomerNumber",
            type: "",
            num:  Math.random(),
            children: [],
        },

    ]
    // taskTableShowNew = false
    tableDataTask = []
    timeStrSecond = ''
    updatePerformanceTasks = ''
    departmentIdOrUserIdList = []
    a = 0
    idlist = []
    needOperation = false

    created() {
        this.getDateInterval()
        this.getMenuData()
    }
    // methods
    openRate() {
        this.taskTableShow = false
        // this.taskTableShowNew = false
        this.raskShow = false
        this.rateShow = true
        this.performanceTasks = ''
    }



    //对比确认弹框
    async confirmRate() {
        // 开始时间
        this.endTime = this.timeRateStr.replace(/&/g, '-')
        this.startTime = this.timeStr.replace(/&/g, '-')
        this.timeStrSecond = this.timeRateStr
        this.tableColumn = [
            {
                id: 2,
                label: "部门人员",
                prop: "name",
                type: "",
                num:  Math.random(),
                children: [],
            },
            {
                id: 3,
                label: "学员数",
                prop: "customerNumber",
                type: "",
                num:  Math.random(),
                children: [
                    {
                        id: 31,
                        label: this.startTime,
                        prop: "customerNumber",
                        type: "",
                        num:  Math.random(),
                    },
                    {
                        id: 32,
                        label: this.endTime,
                        prop: "customerNumberSecond",
                        type: "",
                        num:  Math.random(),
                    },
                ],
            },
            {
                id: 4,
                label: "订单数",
                prop: "financeOrderNumber",
                type: "",
                num:  Math.random(),
                children: [
                    {
                        id: 41,
                        label: this.startTime,
                        prop: "financeOrderNumber",
                        type: "",
                        num:  Math.random(),
                    },
                    {
                        id: 42,
                        label: this.endTime,
                        prop: "financeOrderNumberSecond",
                        type: "",
                        num:  Math.random(),
                    },
                ],
            },
            {
                id: 5,
                label:"结算金额",
                prop: "financeOrderPriceSum",
                type: "",
                num:  Math.random(),
                children: [
                    {
                        id: 51,
                        label: this.startTime,
                        prop: "financeOrderPriceSum",
                        type: "",
                        num:  Math.random(),
                    },
                    {
                        id: 52,
                        label: this.endTime,
                        prop: "financeOrderPriceSumSecond",
                        type: "",
                        num:  Math.random(),
                    },
                ],
            },
            {
                id: 6,
                label: "回款金额",
                prop: "financeBackMoneySum",
                type: "",
                num:  Math.random(),
                children: [
                    {
                        id: 61,
                        label: this.startTime,
                        prop: "financeBackMoneySum",
                        type: "",
                        num:  Math.random(),
                    },
                    {
                        id: 62,
                        label: this.endTime,
                        prop: "financeBackMoneySumSecond",
                        type: "",
                        num:  Math.random(),
                    },
                ],
            },
            {
                id: 7,
                label: "平均签约成本（不含差旅招待）",
                prop: "averageCost",
                type: "",
                num:  Math.random(),
                children: [
                    {
                        id: 71,
                        label: this.startTime,
                        prop: "averageCost",
                        type: "",
                        num:  Math.random(),
                    },
                    {
                        id: 72,
                        label: this.endTime,
                        prop: "averageCostSecond",
                        type: "",
                        num:  Math.random(),
                    },
                ],
            }
        ]
        this.getData()
        this.rateShow = false
        this.timeStrSecond = ''
    }

    // 设置业绩任务确认
    confirmPerformanceTasksShow() {
        this.taskTableShow = true
        this.departmentIdOrUserIdList = []
            this.updatePerformanceTasks = this.performanceTasks
            this.tableData.forEach((item, index) => {
                this.departmentIdOrUserIdList.push(item.id)
            })
            // 请求接口

            if (this.departmentIdOrUserIdList.length > 0 ) {
                const obj = {
                    departmentIdOrUserIdList: this.departmentIdOrUserIdList,
                    taskVolume: this.updatePerformanceTasks ? Number(this.updatePerformanceTasks) : 0,
                    customerNumber: this.performanceStudents ? Number(this.performanceStudents) : 0,
                }
                setFinanceAchievementTask(obj).then(() => {
                    this.performanceTasksShow = false
                    this.SetEnrollmentNumbersVisible = false // 招生人数
                    // this.taskTableShowNew = true
                    this.tableData.forEach((item, index) => {
                        if (this.performanceStudents) {
                            this.$set(this.tableData[index], 'taskCustomerNumber', this.performanceStudents)
                        }
                        if (this.updatePerformanceTasks) {
                            this.$set(this.tableData[index], 'taskVolume', this.updatePerformanceTasks)
                            item.taskVolumeRatio = (Number(item.financeOrderPriceSum / (Number(item.taskVolume) ? item.taskVolume : 1)) * 100).toFixed(2) + '%'
                        }
                    })
                    this.$message.success('批量设置' + (this.updatePerformanceTasks ? '业绩任务' : '招生人数') + '完成')
                    this.departmentIdOrUserIdList = []
                    this.performanceStudents = ''
                    this.getData()
                }).catch((err) => {
                    console.log(err)
                })
            }

    }



    openSetRask() {
        this.performanceTasks = ''
        this.performanceTasksShow = true
        // this.timeRateStrIsShow = ''
        this.timeTypeNew = '1'
        this.timeStrSecDate = [this.today, this.today]
        // this.timeRateStr = this.today + '&' + this.today
        this.timeStrSecond = ''
        this.raskShow = true


    }

    async getMenuData(departmentId = '') {
        let arr = []
        const obj = {
            departmentId: Number(departmentId),
            timeStr: this.timeStr,
        }
        if (!obj.departmentId) {
            delete obj.departmentId
        }
        financeArchiveStatisticalData(obj).then((res: any) => {
            arr = res.departmentAndUserLsit
            if (!departmentId) this.departmentList = res.departmentAndUserLsit.map(item => ({
                    ...item,
                    checked: true
                })
            )

        })
        return arr
    }
    formatter (row, column, cellValue) {
        if(column.property == "customerNumber" || column.property == "financeOrderPriceSum"|| column.property == "financeOrderNumber"|| column.property == "financeBackMoneySum" || column.property === 'souCoursePriceSum'){  // 根据每一列字段，判断哪些需要千分位
          cellValue += ''
          if (!cellValue.includes('.')) cellValue += '.'
          return cellValue.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
            return $1 + ','
          }).replace(/\.$/, '')
        }else{
          return cellValue
        }
      }

    numberToCurrencyNo (value)  {

        if (!value) return 0

        // 获取整数部分

        const intPart = Math.trunc(value)

        // 整数部分处理，增加,

        const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')

        // 预定义小数部分

        let floatPart = ''

        // 将数值截取为小数部分和整数部分

        const valueArray = value.toString().split('.')

        if (valueArray.length === 2) { // 有小数部分

            floatPart = valueArray[1].toString() // 取得小数部分

            return intPartFormat + '.' + floatPart

        }

        return intPartFormat + floatPart

    }

    //确认部门按钮
    doConfirm(){
        this.getData()
    }

    changeCheck(val) {
        this.idlist = []
        if (this.departmentList && this.departmentList.length > 0) {
            this.departmentList.forEach((item) => {
                if (item.checked === true) {
                    this.idlist.push(item.id)
                }
            })
        }
        this.$nextTick(() => {
            this.needOperation = true
        })
    }
    // 列表数据
     getData() {
        const loading = Loading.service({
            text: '正在加载，请稍后'
        })
        const obj = {
            departmentId: Number(this.departmentId),
            timeStr: this.timeStr,
            timeStrSecond: this.timeStrSecond,
            showDepartmentIdList: []
        }
        obj.showDepartmentIdList = this.idlist
        for(const key in obj) {
            if(obj[key].length == 0 || !obj[key]) {
                delete obj[key]
            }
        }
        financeArchiveStatisticalData(obj).then((data : any)=>{
            if (data.departmentAndUserLsit) {
                const resData = data.departmentAndUserLsit
                // 数据对比
                this.tableData = resData.map((item) => item.customerNumberSecond ? (
                    {
                        ...item,
                        customerNumberOne: item.customerNumber,
                        financeOrderNumberOne: item.financeOrderNumber,
                        financeOrderPriceSumOne: item.financeOrderPriceSum,
                        financeBackMoneySumOne: item.financeBackMoneySum,
                        averageCost: item.averageCost,
                    }) : {...item})

                // 设置业绩任务
                // if (this.updatePerformanceTasks) {
                //     this.tableData = resData.map((item) => ({
                //         ...item,
                //         task: this.updatePerformanceTasks,
                //         taskRate: (Number(item.financeOrderPriceSum / (Number(item.task) ? item.task : 1)) * 100).toFixed(2)
                //     }))
                // }
            }
            this.needOperation = false
            loading.close()
        })
    }
    handleOninput(num,limit) {
        const len1 = num.charAt(0)
        // 转化为数字形式--包含小数，负数
        // 先把非数字的都替换掉，除了数字和.
        num = num.replace(/[^\d.]/g, '')
        // 必须保证第一个为数字而不是.
        num = num.replace(/^\./g, '')
        // 保证只有出现一个.而没有多个.
        num = num.replace(/\.{2,}/g, '.')
        // 保证.只出现一次，而不能出现两次以上
        num = num.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        // 如果第一位是负号，则允许添加
        if (len1 === '-') {
            num = '-' + num
        }
        return num
    }

    changeTask(row, val) {
        val = this.handleOninput(val, 2)
        row.taskVolume = this.handleOninput(val, 2)
        const obj = {
            departmentIdOrUserIdList: [row.id],
            taskVolume: val ? Number(val) : 0,
            customerNumber: Number(row.taskCustomerNumber)
        }
        if (row.id) {
            setFinanceAchievementTask(obj)
            // this.getData()
        }

    }

    changeStudent(row, val) {
        val = this.handleOninput(val, 2)
        row.customerNumber = this.handleOninput(val, 2)
        const obj = {
            departmentIdOrUserIdList: [row.id],
            taskVolume: Number(row.taskVolume),
            customerNumber: val ? Number(val) : 0
        }
        if (row.id) {
            setFinanceAchievementTask(obj)
            // this.getData()
        }

    }

    changePage(val: string) {
        this.page = Number(val)
        // this.initNosettingList()
    }

    getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '总计';
                return;
            }
            const values = data.map(item => Number(item[column.property]));
            if (column.property != 'taskRate') {
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return math.number(math.add(math.bignumber(prev), math.bignumber(curr)))
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] += '';
                    for (let i = 1; i < sums.length; i++) {
                        const reg = /\d{1,3}(?=(\d{3})+$)/g
                        sums[i] = sums[i].replace(reg, '$&,')
                    }
                } else {
                    let sum1 = 0
                    let sum2 = 0
                    data.forEach(item => {
                        sum1 += Number(item.financeOrderPriceSum)
                        sum2 += Number(item.taskVolume)
                    })
                    let finalVal = ''
                    if (sum1!==0 && sum2!==0) {
                        finalVal = ((sum1 / sum2) * 100).toFixed(2) + '%'
                        sums[index] = finalVal
                    } else {
                        sums[index] = Number(0).toFixed(2)+'%'
                    }


                }
            }

        })
        return sums;
    }

    changeRadio(val: number) {
        this.dataFilter = val
        // this.getMenuData()
    }
    handleOpen(key, keyPath) {
        this.activeIndex = key
        this.departmentId = key
        this.fun(this.departmentList, keyPath, 0)
        this.getData()
    }
    handleSelect(key, keyPath) {
        this.activeIndex = key
        this.getData()
    }
    handleClose(key, keyPath) {
        if(keyPath.length == 1){
            this.departmentId = ''
        }else if(keyPath.length == 3) {
            this.departmentId = keyPath[1]
        }else if(keyPath.length > 1) {
            this.departmentId = keyPath[0]
        }
        this.activeIndex = key
        this.fun(this.departmentList, keyPath, 0)
        this.getData()
    }

    fun(departmentList, idList, index) {
        if(idList.length === index) return
        const departmentId = idList[index]
        const obj = departmentList.filter(item => item.id === Number(departmentId))[0]

            if(obj.children) {
                this.fun(obj['children'], idList, ++index)
            } else {
                financeArchiveStatisticalData({ departmentId: Number(departmentId) ,timeStr:this.timeStr}).then((res: any) => {
                    // obj['children'] = res.departmentAndUserLsit
                    this.$set(obj, 'children', res.departmentAndUserLsit)
                    this.$forceUpdate()
                    if(obj.children.length > 0){
                        for(const key in obj) {
                            obj['subMenu'] = true
                        }
                    }
                    if(obj.children.length == 0){
                        for(const key in obj) {
                            obj['subMenu'] = false
                        }
                    }
                })
            }

    }


    //    初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '0') {
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
            this.getData()
        } else if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            this.getData()
        }

        if (this.timeTypeNew == '1') {
            this.timeRateStr = this.today + '&' + this.today
            this.timeStrSecDate = [this.today, this.today]
        }

    }
    // 选择区间
    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek,this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth,this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter,this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear,this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek,this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth,this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter,this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart,this.yesteryearEnd]
        }else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday,this.yesterday]
        }else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today,this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }


        if (this.timeStr) {
            this.tableColumn = [  //表头
                {
                    id: 2,
                    label: "部门人员",
                    prop: "name",
                    type: "",
                    num:  Math.random(),
                    children: [],

                },
                {
                    id: 3,
                    label: "学员数",
                    prop: "customerNumber",
                    type: "",
                    children: [],
                    num:  Math.random(),

                },
                {
                    id: 4,
                    label: "订单数",
                    prop: "financeOrderNumber",
                    type: "",
                    num:  Math.random(),
                    children: [],

                },
                {
                    id: 7,
                    label: "项目终端售价",
                    prop: "souCoursePriceSum",
                    type: "",
                    num:  Math.random(),
                    children: [],

                },
                {
                    id: 5,
                    label:"结算金额",
                    prop: "financeOrderPriceSum",
                    type: "",
                    num:  Math.random(),
                    children: [],

                },
                {
                    id: 6,
                    label: "回款金额",
                    prop: "financeBackMoneySum",
                    type: "",
                    num:  Math.random(),
                    children: [],

                },
                {
                    id: 10,
                    label: "平均签约成本（不含差旅招待）",
                    prop: "averageCost",
                    type: "",
                    num:  Math.random(),
                    children: [],
                },

                {
                    id: 8,
                    label: "业绩任务",
                    prop: "taskVolume",
                    type: "",
                    num:  Math.random(),
                    children: [],

                },
                {
                    id: 9,
                    label: "业绩完成率",
                    prop: "taskVolumeRatio",
                    type: "",
                    num:  Math.random(),
                    children: [],

                },
                {
                    id: 10,
                    label: "招生人数",
                    prop: "taskCustomerNumber",
                    type: "",
                    num:  Math.random(),
                    children: [],

                },
            ]
            // this.taskTableShowNew = false
            this.getData()
        }

    }

    changeDateTypeNew(val) {
        if (val === '2') {  //    本周
            this.timeRateStr = this.startWeek + '&' + this.endWeek
            this.timeStrSecDate = [this.startWeek,this.endWeek]
        } else if (val === '3') { // 本月
            this.timeRateStr = this.startMonth + '&' + this.endMonth
            this.timeStrSecDate = [this.startMonth,this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeRateStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrSecDate = [this.startQuarter,this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeRateStr = this.startYear + '&' + this.endYear
            this.timeStrSecDate = [this.startYear,this.endYear]
        } else if (val === '6') { // 上周
            this.timeRateStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrSecDate = [this.startLastWeek,this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeRateStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrSecDate = [this.startLastMonth,this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeRateStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrSecDate = [this.startLastQuarter,this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeRateStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrSecDate = [this.yesteryearStart,this.yesteryearEnd]
        }else if (val === '0') { // 昨天
            this.timeRateStr = this.yesterday + '&' + this.yesterday
            this.timeStrSecDate = [this.yesterday,this.yesterday]
        }else if (val === '1') { // 今天
            this.timeRateStr = this.today + '&' + this.today
            this.timeStrSecDate = [this.today,this.today]
        } else {
            this.timeRateStr = ''
            this.timeStrSecDate = []
        }

    }

    handleChangeData(val) {
        const  week = [this.startWeek,this.endWeek]
        const  month = [this.startMonth,this.endMonth]
        const  year = [this.startYear,this.endYear]
        const  quarter = [this.startQuarter,this.endQuarter]
        const  lastWeek = [this.startLastWeek,this.endLastWeek]
        const  lastMonth = [this.startLastMonth,this.endLastMonth]
        const  lastQuarter = [this.startLastQuarter,this.endLastQuarter]
        const  lastyear = [this.yesteryearStart,this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        }  else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        }else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        // this.taskTableShowNew = false

        this.getData()
        this.tableColumn = [  //表头
            {
                id: 2,
                label: "部门人员",
                prop: "name",
                type: "",
                num: Math.random(),
                children: [],

            },
            {
                id: 3,
                label: "学员数",
                prop: "customerNumber",
                type: "",
                children: [],
                num: Math.random(),

            },
            {
                id: 4,
                label: "订单数",
                prop: "financeOrderNumber",
                type: "",
                num: Math.random(),
                children: [],

            },
            {
                id: 7,
                label: "项目终端售价",
                prop: "souCoursePriceSum",
                type: "",
                num: Math.random(),
                children: [],

            },
            {
                id: 5,
                label: "结算金额",
                prop: "financeOrderPriceSum",
                type: "",
                num: Math.random(),
                children: [],

            },
            {
                id: 6,
                label: "回款金额",
                prop: "financeBackMoneySum",
                type: "",
                num: Math.random(),
                children: [],

            },
            {
                id: 10,
                label: "平均签约成本（不含差旅招待）",
                prop: "averageCost",
                type: "",
                num:  Math.random(),
                children: [],
            },

            {
                id: 8,
                label: "业绩任务",
                prop: "taskVolume",
                type: "",
                num:  Math.random(),
                children: [],

            },
            {
                id: 9,
                label: "业绩完成率",
                prop: "taskVolumeRatio",
                type: "",
                num:  Math.random(),
                children: [],

            },
            {
                id: 10,
                label: "招生人数",
                prop: "taskCustomerNumber",
                type: "",
                num:  Math.random(),
                children: [],

            },
        ]
    }

    handleChangeDataNew(val) {
        const week = [this.startWeek, this.endWeek]
        const month = [this.startMonth, this.endMonth]
        const year = [this.startYear, this.endYear]
        const quarter = [this.startQuarter, this.endQuarter]
        const lastWeek = [this.startLastWeek, this.endLastWeek]
        const lastMonth = [this.startLastMonth, this.endLastMonth]
        const lastQuarter = [this.startLastQuarter, this.endLastQuarter]
        const lastyear = [this.yesteryearStart, this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '5'
        } else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '9'
        } else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeTypeNew = '1'
        } else {
            this.timeTypeNew = '自定义时间'
        }


        this.timeRateStr = val[0] + '&' + val[1]

    }
}
